import React, { Component } from 'react';
import _ from 'lodash';

import UserImage from '../../assets/images/userimage.png';

export default class RenderWorkflowProcessHistory extends Component {
  constructor(props){
    super(props)

    this.renderHistory = this.renderHistory.bind(this);
    this.renderTrackingHistoryRow = this.renderTrackingHistoryRow.bind(this);
  }


  renderHistory(focus_workflow_process_history){
    const {workflow_process_id, document_id, document_template_id, positions_users, state_name, action_name, created_at, updated_at} = focus_workflow_process_history;

    const workflow_procses_path = `/templates/documents/${document_id}/show/${document_template_id}/wp/${workflow_process_id}`;

    return(
      <div>
        <h4>ผู้ดำเนินงาน</h4>
        <hr className="mb-3" />

        {_.map(positions_users, function(positions_user, index){
          return(
            <div key={index} className="row mb-3">
              <div className="col-4 text-center">
                <img alt='profile' src={UserImage}/>
              </div>
              <div className="col-8">
                <h4>{positions_user.user_name}</h4>
                <div><i className="fa fa-user"></i>{' '}{positions_user.position_name}</div>
                <div><i className="fa fa-mail-forward"></i>{' '}{ created_at }</div>
                {updated_at && (
                  <div><i className="fa fa-mail-reply"></i>{' '}{ updated_at }</div>
                )}
                {action_name && (
                  <div><i className="fa fa-check-square-o"></i>{' '}{action_name}</div>
                )}
                {state_name && (
                  <div><i className="fa fa-envelope-o"></i>{' '}{state_name}</div>
                )}
              </div>
            </div>
          )
        })}

        <div className="row">
          <div className="offset-4 col-8">
            <a href={workflow_procses_path} target="_blank" className="btn btn-success">แสดงเอกสาร</a>
          </div>
        </div>

      </div>
    )
  }

  renderCampusHistory(focus_workflow_process_history){
    const {campus_code, campus_name, state_name, timestamp, is_campus, workflow_process_histories} = focus_workflow_process_history;
    const tracking_histories = workflow_process_histories;

    return(
      <div>
        <h4>ผู้ดำเนินงาน</h4>
        <hr className="mb-3" />

        
        <div className="row mb-3">
          <div className="col-4 text-center">
            <img alt='profile' src={UserImage}/>
          </div>
          <div className="col-8">
            <h4>{campus_name}</h4>
            <div>ประวัติการดำเนินงาน:</div>
            {_.map(tracking_histories, this.renderTrackingHistoryRow)}

            <br />
            <div>สถานะล่าสุด:</div>
            <div><i className="fa fa-user"></i>{' '}{`สารบรรณ${campus_name}`}</div>
            <div><i className="fa fa-mail-reply"></i>{' '}{ timestamp }</div>
            {state_name && (
              <div><i className="fa fa-envelope-o"></i>{' '}{state_name}</div>
            )}
          </div>
        </div>
      </div>
    )
  }

  renderTrackingHistoryRow(tracking_history){
    console.log(tracking_history);

    const state_name = _.get(tracking_history, "attributes.state_name");
    const action_name = _.get(tracking_history, "attributes.action_name");
    const timestamp = _.get(tracking_history, "attributes.timestamp");

    return(
      <div>
        <i className="fa fa-check-square-o"></i>{' '}
        <span>
          {state_name}{" - "}
          <b>{action_name}</b>
          {" "}({timestamp})
        </span>
      </div>
    )
  }

  render() {
    return(
      <div>
        {(this.props.focus_workflow_process_history.is_campus == true) ? (
          this.renderCampusHistory(this.props.focus_workflow_process_history)
        ) : (
          this.renderHistory(this.props.focus_workflow_process_history)
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/FullHistory/RenderWorkflowProcessHistory.js